import { ICON_CHOICES } from '../Cards/icons';

const ButtonSchema = (props) => ({
  title: 'AgSUS Botão',
  fieldsets: [
    { id: 'default', title: 'Conteúdo', fields: ['label', 'href', 'openInNewTab'] },
    { id: 'style', title: 'Estilo', fields: ['variant', 'size', 'align'] },
    { id: 'icon', title: 'Ícone', fields: ['iconPosition', 'icon'] },
  ],
  properties: {
    label: { title: 'Texto do botão', default: 'Saiba mais' },
    href: { title: 'Endereço do link' },
    openInNewTab: {
      title: 'Abrir em nova aba',
      type: 'boolean',
      default: false,
    },
    variant: {
      title: 'Cor / variante',
      choices: [
        ['primary', 'Primário (azul preenchido)'],
        ['ghost', 'Vazado (outline azul)'],
        ['red', 'Vermelho (alerta)'],
        ['yellow', 'Amarelo (destaque)'],
      ],
      default: 'primary',
    },
    size: {
      title: 'Tamanho',
      choices: [
        ['sm', 'Pequeno'],
        ['md', 'Médio (padrão)'],
        ['lg', 'Grande'],
      ],
      default: 'md',
    },
    align: {
      title: 'Alinhamento',
      choices: [
        ['left', 'Esquerda'],
        ['center', 'Centro'],
        ['right', 'Direita'],
      ],
      default: 'left',
    },
    iconPosition: {
      title: 'Posição do ícone',
      choices: [
        ['none', 'Sem ícone'],
        ['left', 'Antes do texto'],
        ['right', 'Após o texto (seta default)'],
      ],
      default: 'none',
    },
    icon: {
      title: 'Ícone (opcional)',
      description: 'Se vazio e posição = direita, usa seta →.',
      choices: ICON_CHOICES,
      default: '',
    },
  },
  required: [],
});

export default ButtonSchema;
